import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Widget as WidgetContainer, WidgetSection } from '@factorialco/f0-react/dist/experimental'
import { Clock, Crown, Target } from '@factorialco/f0-react/icons/app'

import { i18nDateToString } from 'modules/core/lib/dates'
import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import ExtraHoursUtils from 'modules/attendance/lib/utils/ExtraHoursUtils'

const ComplementaryHoursCounter = () => {
  const { balances, complementaryHoursMinutes, currentEmployeesSetting } = useTimesheetData()

  const getComplementaryHoursDescription = () => {
    const isCalculatingComplementaryHours = ExtraHoursUtils.isCalculatingExtraHours(balances)

    if (isCalculatingComplementaryHours) {
      const complementaryHoursCalculationOn = ExtraHoursUtils.extraHoursCalculationOn(balances)
      const complementaryHoursCalculationOnDateString = i18nDateToString(
        complementaryHoursCalculationOn,
        'ui_dmy_long'
      )

      return {
        title: i18n.t('clock_in.complementary_hours_widget.calculation_in_progress', {
          endDate: complementaryHoursCalculationOnDateString,
        }),
        icon: Clock,
        isCalculating: true,
        complementaryHours: 0,
      }
    }

    if (complementaryHoursMinutes === 0) {
      return {
        title: i18n.t('clock_in.complementary_hours_widget.on_track'),
        icon: Target,
        isCalculating: false,
        complementaryHours: complementaryHoursMinutes,
      }
    }

    return {
      title:
        (currentEmployeesSetting?.complementaryHoursBaseline ?? 'contract_hours') ===
        'contract_hours'
          ? i18n.t('clock_in.complementary_hours_widget.complementary_hours_accumulated_contract')
          : i18n.t('clock_in.complementary_hours_widget.complementary_hours_accumulated_planned'),
      icon: Crown,
      isCalculating: false,
      complementaryHours: complementaryHoursMinutes,
    }
  }

  const { title, icon, isCalculating, complementaryHours } = getComplementaryHoursDescription()

  return (
    <WidgetContainer
      header={{
        title: i18n.t('clock_in.complementary_hours_widget.title'),
      }}
    >
      <WidgetSection title={title}>
        <Box inline flexDirection="row" gap="s8" alignItems="center">
          <F0Icon icon={icon} size="lg" color="primary" />
          <Box className="text-2xl text-f1-foreground font-semibold cursor-default">
            {isCalculating ? '-' : minutesToText(complementaryHours, false, true)}
          </Box>
        </Box>
      </WidgetSection>
    </WidgetContainer>
  )
}

export default ComplementaryHoursCounter
